var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{staticStyle:{"background-color":"var(--v-background-base)"},attrs:{"app":""}},[_c('app-bar'),_c('v-main',[_c('hero-img'),_c('go-to'),_c('about-section'),_c('social-section'),_c('back-to-top')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }